export class Mount {
  description: string;
  source: string;
  target: string;

  constructor(description: string, source: string, target: string) {
    this.description = description;
    this.source = source;
    this.target = target;
  }
}